import axios from "axios";

// const baseUrlForEnvironment = 'https://pmeinter.com';
const baseUrlForEnvironment = process.env.NODE_ENV ==='development' ? 'http://pmeinter.localhost' : 'https://pmeinter.com';
// const baseUrlForEnvironment = 'http://pme.test';
// process.env.NODE_ENV === 'development' ? 'https://pme.stagewink.com' : 'https://pmeinter.com';

const tokenAxios = axios.create({
    baseURL: baseUrlForEnvironment + '/wp-json/jwt-auth/v1/token',
});

const pagesAxios = axios.create({
    baseURL: baseUrlForEnvironment + '/wp-json/pme/extranet/v1/page/',
});

const bdAxios = axios.create({
    baseURL: baseUrlForEnvironment + '/wp-json/pme/bd/v1/',
});

export {tokenAxios, pagesAxios, bdAxios, baseUrlForEnvironment};
